/* istanbul ignore file */
import React, { useRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import { TableCell, TableRow } from "@material-ui/core/";

import classes from "../GenomeTable.module.css";
import theme from "../../../themes/theme.module.css";
import JDPTooltip from "../../UI/Tooltip/Tooltip";

const OverflowWithTipTableRow = ({ header, value }) => {
  const [showMore, setShowMore] = useState(false);
  const textElementRef = useRef();

  const compareSize = () => {
    const compare =
      textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
    setShowMore(compare);
  };

  useEffect(() => {
    compareSize();
    window.addEventListener("resize", compareSize);

    // remove resize listener again on "componentWillUnmount"
    return () => {
      window.removeEventListener("resize", compareSize);
    };
  }, []);

  return (
    <TableRow className={classes.headerRow}>
      <TableCell
        style={{
          maxWidth: 100,
          paddingRight: 0,
        }}
      >
        <Typography
          ref={textElementRef}
          sx={{
            textWrap: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontFamily: "Merriweather",
            fontSize: 22,
          }}
          data-testid={`${header.toLowerCase().replace(/ /g, "-")}`}
        >
          <span
            style={{
              fontWeight: "bold",
            }}
          >
            {header}:
          </span>
          <span
            style={{
              marginLeft: 12,
            }}
          >
            {value}
          </span>
        </Typography>
      </TableCell>
      {showMore && (
        <TableCell style={{ width: 60, padding: 0 }}>
          <JDPTooltip iconType={null} title={value} placement="left-start">
            <Typography
              style={{
                marginLeft: 4,
                padding: 0,
                fontFamily: "Merriweather",
                fontSize: 18,
                fontWeight: "bold",
                fontStyle: "italic",
                color: theme.lake500,
                textDecoration: "underline",
              }}
            >
              more
            </Typography>
          </JDPTooltip>
        </TableCell>
      )}
    </TableRow>
  );
};

export default OverflowWithTipTableRow;

OverflowWithTipTableRow.defaultProps = {
  header: "",
  value: "",
};

OverflowWithTipTableRow.propTypes = {
  header: PropTypes.string,
  value: PropTypes.string,
};
